
import { defineComponent } from 'vue';
import ResizableImage from '@/shared/components/ResizableImage.vue';

import RegistrationAgent from './RegistrationAgent.vue';
import { mapGetters } from 'vuex';
import config from '@/shared/constants/config';

export default defineComponent({
  components: {
    RegistrationAgent,
    ResizableImage,
  },
  data() {
    return {
      logoUrl: config.BASE_URL + '/img/logo.svg',
      domain: config.DOMAIN,
      competition: null,
    };
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
  },
  created() {
    if (this.isLoggedIn) {
      this.$router.push({ name: 'AdFormCreate' });
    }
  },
});
